import React from 'react';
import propTypes from 'prop-types';

function PageSectionHeaderHead({ imageComponent, title, description }) {
  // append class to the image component
  const imageComponentWithClass = React.cloneElement(imageComponent, {
    className: 'page-section-header__image'
  });
  return (
    <div className="page-section-header__head">
      {imageComponentWithClass}
      <div className="page-section-header__content">
        <div className="page-section-header__title">{title}</div>
        <div className="page-section-header__description">{description}</div>
      </div>
    </div>
  );
}

PageSectionHeaderHead.propTypes = {
  imageComponent: propTypes.node,
  title: propTypes.string,
  description: propTypes.string
};

PageSectionHeaderHead.defaultProps = {
  imageComponent: null,
  title: '',
  description: ''
};

export default PageSectionHeaderHead;
